(function () {
  "use strict";

  class CartBar extends HTMLElement {
    constructor() {
      super();
      this.onScroll = this.toggleCartBarOnScroll.bind(this);
      this.onResize = this.setCartBarHeight.bind(this);
      this.onError = this.handleProductAddError.bind(this);
      this.onClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      const sectionId = this.id.replace(/^CartBar-/, "");

      this.section =
        this.closest("product-info") ||
        document.getElementById("MainProduct--" + sectionId);

      this.form = this.section?.querySelector("[data-product-form]");
      if (!this.form) return;

      this.formWrapper = this.form;
      this.applyButtonStyles();

      this.addEventListener("click", this.onClick);
      window.addEventListener("scroll", this.onScroll, {
        passive: true
      });
      window.addEventListener("resize", this.onResize);
      document.addEventListener("theme:resize", this.onResize);
      document.addEventListener("theme:product:add-error", this.onError);

      this.setCartBarHeight();
      this.toggleCartBarOnScroll();
    }

    applyButtonStyles() {
      let style = document.getElementById("hunny-cart-bar-styles");

      if (!style) {
        style = document.createElement("style");
        style.id = "hunny-cart-bar-styles";
        document.head.appendChild(style);
      }

      style.textContent = `
        .cart-bar [data-cart-bar-add-to-cart] {
          background: #d4af37 !important;
          color: #0d1b2a !important;
          border: 2px solid #d4af37 !important;
          border-radius: 999px !important;
          min-height: 48px;
        }

        .cart-bar [data-cart-bar-add-to-cart] .btn__text {
          color: #0d1b2a !important;
        }

        .cart-bar [data-cart-bar-add-to-cart]:hover {
          background: #c5a22e !important;
          border-color: #c5a22e !important;
        }

        .cart-bar [data-cart-bar-add-to-cart]:focus-visible {
          outline: 2px solid #ffffff;
          outline-offset: 3px;
        }

        @media only screen and (max-width: 749px) {
          .cart-bar {
            height: auto !important;
            padding-bottom: calc(
              16px + env(safe-area-inset-bottom, 0px)
            ) !important;
            box-sizing: border-box;
          }
        }
      `;
    }

    handleClick(event) {
      const button = event.target.closest(
        "[data-cart-bar-add-to-cart]"
      );

      if (button) {
        const productForm = this.form.closest("product-form");
        if (!productForm) return;

        event.preventDefault();
        button.classList.add("is-loading");
        button.setAttribute("disabled", "disabled");
        productForm.onSubmitHandler(event);
      }

      if (event.target.closest("[data-cart-bar-scroll]")) {
        event.preventDefault();
        this.scrollToTop();
      }
    }

    handleProductAddError() {
      this.scrollToTop();
    }

    scrollToTop() {
      const target =
        this.section.querySelector("variant-selects") || this.form;

      target.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }

    toggleCartBarOnScroll() {
      if (!this.formWrapper) return;

      this.classList.toggle(
        "is-visible",
        this.formWrapper.getBoundingClientRect().bottom < 0
      );
    }

    setCartBarHeight() {
      document.documentElement.style.setProperty(
        "--cart-bar-height",
        `${this.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
      window.removeEventListener("scroll", this.onScroll);
      window.removeEventListener("resize", this.onResize);
      document.removeEventListener("theme:resize", this.onResize);
      document.removeEventListener("theme:product:add-error", this.onError);
    }
  }

  if (!customElements.get("cart-bar")) {
    customElements.define("cart-bar", CartBar);
  }
})();